import axios from 'axios';

// Get API URL from localStorage or use default
const getApiBaseURL = () => {
  const savedApiUrl = localStorage.getItem('apiUrl');
  if (savedApiUrl) {
    return savedApiUrl;
  }
  return process.env.NODE_ENV === 'production' 
    ? '/api'  // Vercel serverless functions (relative path)
    : 'http://localhost:3001/api';  // Localhost for development
};

// Create axios instance with base configuration
const api = axios.create({
  baseURL: getApiBaseURL(),
  timeout: 60000, // Increased to 60 seconds for complex analytics with comparison
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to update base URL dynamically
export const updateApiBaseURL = (newBaseURL) => {
  api.defaults.baseURL = newBaseURL;
};

// Make it available globally for Settings component
if (typeof window !== 'undefined') {
  window.updateApiBaseUrl = updateApiBaseURL;
}

// Request interceptor: voeg API key toe aan elke request
export const APP_API_KEY = process.env.REACT_APP_API_KEY || 'e4ccbc0bd680211f4e4553ea3ab07d8a55707e79cde61faa10c51c55c6da35a9';

api.interceptors.request.use(
  (config) => {
    config.headers['x-api-key'] = APP_API_KEY;
    console.log(`Making ${config.method?.toUpperCase()} request to:`, config.url);
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    
    // Handle different error types
    if (error.response?.status === 404) {
      throw new Error('Endpoint not found');
    } else if (error.response?.status >= 500) {
      throw new Error('Server error. Please try again later.');
    } else if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    } else {
      throw new Error(error.message || 'Network error');
    }
  }
);

// API methods
export const apiService = {
  // Health check
  healthCheck: () => api.get('/health'),
  
  // Database test
  testDatabase: () => api.get('/health/database'),

  // Products
  getProducts: (params = {}) => api.get('/woocommerce/products', { params }),
  
  // Orders
  getOrders: (params = {}) => api.get('/woocommerce/orders', { params }),
  getPendingOrders: (params = {}) => api.get('/woocommerce/orders/pending', { params }),
  getOrder: (orderId) => api.get(`/woocommerce/orders/${orderId}`),
  searchOrders: (params = {}) => api.get('/woocommerce/orders', { params }),
  getOrdersYears: () => api.get('/woocommerce/orders/years'),
  
  // Customers
  getCustomers: (params = {}) => api.get('/woocommerce/customers', { params }),
  getCustomer: (customerId) => api.get(`/woocommerce/customers/${customerId}`),
  
  // NEW: Product comparison and sync management
  getProductComparison: (params = {}) => api.get('/woocommerce/analytics/product-comparison', { params }),
  getProductSales: (params = {}) => api.get('/woocommerce/analytics/product-sales', { params }),
  getSyncStatus: () => api.get('/woocommerce/sync/status'),
  triggerSync: (fullSync = false) => api.post('/woocommerce/sync/manual', { full_sync: fullSync }),
  stopSync: () => api.post('/woocommerce/sync/stop'),
  
  // Pending Products
  getPendingProducts: (params = {}) => api.get('/woocommerce/pending-products', { params }),
  
  // Order Details
  getOrderDetails: (orderId) => api.get(`/woocommerce/orders/${orderId}`),
  
  // Pricing Analysis
  getPricingAnalysis: (params = {}) => api.get('/woocommerce/pricing-analysis', { params }),
};

export default api; 